import React, { useRef, useState, useCallback } from "react"
import { Sprite, Container, Graphics, useTick } from "@inlet/react-pixi"
import { lerp, clamp } from "utils/math"
import Emitter from "components/emitter"

import texture from "resources/particle.png"
import config from "resources/line-emitter.json"

const Runner = ({ time, data }) => {
  const prevy = 90 + data[Math.floor(time * 4)] * 60
  const nexty = 90 + data[Math.ceil(time * 4)] * 60
  return (
    <Emitter
      x={lerp(30, 270, time)}
      y={lerp(prevy, nexty, time * 4 - Math.trunc(time * 4))}
      image={texture}
      config={config}
    />
  )
}

export default Runner
